import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { UserProvider } from '../src/Componentes/UserContext';
import Home from './Componentes/Home/index';
import Menu from './Componentes/Menu/index';
import Footer from './Componentes/Footer/index';
import Desenvolvimrnto from './Componentes/Desenvolvimentos/index';
import Financeiro from './Componentes/Financeiro/index';
import Grafico from './Componentes/Grafico';
import Agenda from './Componentes/Agenda';

const App = () => {
  return (
    <UserProvider>
      <Router>
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/desenvolvimento" element={<Desenvolvimrnto />} />
            <Route path="/financeiro" element={<Financeiro />} />
            <Route path="/grafico" element={<Grafico />} />
            <Route path="/Agenda" element={<Agenda />} />
          </Routes>
          {/* Rodapé global */}
          <Footer />
        </div>
      </Router>
    </UserProvider>
  );
};

export default App;

